import React, { useMemo, useState } from "react";
import axios from "../api/axios";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useToast } from "../context/ToastContext";

function Resetpass() {
  const { token } = useParams();
  const nav = useNavigate();
  const { notifyLoading, notifySuccess, notifyError } = useToast();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [show, setShow] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const passwordOk = useMemo(() => password.length >= 8, [password]);
  const matchOk = useMemo(
    () => password && confirmPassword && password === confirmPassword,
    [password, confirmPassword]
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      notifyError("Invalid reset link. Please request a new one.");
      return;
    }

    if (!passwordOk) {
      notifyError("Password must be at least 8 characters.");
      return;
    }

    if (!matchOk) {
      notifyError("Password confirmation does not match.");
      return;
    }

    const toastId = notifyLoading("Resetting password...");
    setSubmitting(true);

    try {
      const response = await axios.post(`/api/user/reset-password/${token}`, {
        password,
      });

      // optional: dismiss loading toast
      // toast.dismiss(toastId) -> kalau kau nak, kita boleh expose dismiss dalam ToastContext
      notifySuccess("Successfully reset password. Please login.", { id: toastId });

      // delay sikit bagi user nampak toast
      setTimeout(() => nav("/login"), 1200);
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        "Error resetting password. Please try again.";
      notifyError(msg, { id: toastId });
      setSubmitting(false);
    }
  };

  return (
    <div className="App">
      <div className="container mt-3">
        <div className="row justify-content-center text-center">
          <div className="col-lg-12">
            <h1 className="my-4 header-title">RESET PASSWORD</h1>
          </div>

          <div className="row justify-content-center text-start mt-3">
            <div className="col-12 col-lg-6">
              <div className="card">
                <div className="card-body">
                  <p className="text-muted mb-3" style={{ fontSize: 14 }}>
                    Enter your new password below. Minimum 8 characters.
                  </p>

                  <form onSubmit={handleSubmit}>
                    <div className="mb-2">
                      <label className="form-label">New password</label>
                      <div className="input-group">
                        <input
                          className="form-control"
                          type={show ? "text" : "password"}
                          placeholder="Enter new password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          disabled={submitting}
                          required
                        />
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => setShow((v) => !v)}
                          disabled={submitting}
                        >
                          {show ? "Hide" : "Show"}
                        </button>
                      </div>
                      {!passwordOk && password.length > 0 && (
                        <div className="text-danger mt-1" style={{ fontSize: 12 }}>
                          Password must be at least 8 characters.
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Confirm password</label>
                      <input
                        className="form-control"
                        type={show ? "text" : "password"}
                        placeholder="Confirm new password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        disabled={submitting}
                        required
                      />
                      {confirmPassword.length > 0 && !matchOk && (
                        <div className="text-danger mt-1" style={{ fontSize: 12 }}>
                          Password confirmation does not match.
                        </div>
                      )}
                    </div>

                    <div className="d-grid">
                      <button
                        className="btn btn-sm btn-dark"
                        type="submit"
                        disabled={submitting}
                      >
                        {submitting ? "Resetting..." : "Reset Password"}
                      </button>
                    </div>
                  </form>

                  <div className="mt-3 text-center">
                    <Link to="/login" className="text-decoration-none">
                      Back to Sign In
                    </Link>
                  </div>
                </div>
              </div>

              <div className="text-center mt-3" style={{ fontSize: 12, color: "#6c757d" }}>
                If your link expired, request a new reset link from Forgot Password.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Resetpass;
